$(document).ready(function(){ 

  $(".messure_info").click(function(){
    $(".info_first").toggle()
  })
  $(".motive_color").click(function(){
    $(".info_second").toggle()
  })
  var current_action='inches';
  $('.custom-size-action-radio').change(function(){    
      var $this  = $(this);
      $(".mesure").hide();
      $(".mesure :input").attr('disabled','disabled');
      destroycroper();
      if($this.is(':checked')){
           current_action = $this.val();        
          if(current_action == "inches"){
            $(".inc_container").show()
            $(".inc_container :input").removeAttr('disabled')
          }else if(current_action == "ft"){
            $(".inc_ft_container").show()
            $(".inc_ft_container :input").removeAttr('disabled');
          }else if(current_action == "cm"){
            $(".cm_container").show()
            $(".cm_container :input").removeAttr('disabled');
          }else{
            alert("Invalid action");
            return false;
          }
          
      }
  });

  

 // function gcd (u, v) {
 //      if (u === v) return u;
 //      if (u === 0) return v;
 //      if (v === 0) return u;
  
 //      if (~u & 1)
 //          if (v & 1)
 //              return gcd(u >> 1, v);
 //          else
 //              return gcd(u >> 1, v >> 1) << 1;
  
 //      if (~v & 1) return gcd(u, v >> 1);
  
 //      if (u > v) return gcd((u - v) >> 1, v);
  
 //      return gcd((v - u) >> 1, u);
 //  }

  /* returns an array with the ratio */
  // function ratio (w, h) {
  // 	var d = gcd(w,h);
  // 	return [w/d, h/d];
  // }
  

/*********Croper**************/
    var is_init = false;
    var image_ratio = 1;
    var height_set=500;
    var width_set=500;
    var original_image_customer='';

    var resolution = '';
    var width_render = '';
    var height_render = '';
    var width_pass = '';
    var height_pass = '';
    var quantity = '';
    var cropper ='';
     
    //setPriceInit();
    setPriceFirstVariantInit();
    function getPrice(){
      return $(".base_price").attr('data-price');
      //return $('.selected-variant').attr('data-price');
    }
    function setPriceInit(){
      var price  = $(".base_price").attr('data-price');
      price =  parseInt(price / 100) + "." + (price % 100);
      $(".base_price").attr('data-price',price);
    }
  function setPriceFirstVariantInit(){
      var price  = $(".base_price").attr('data-price');
      price =  parseInt(price / 100) + "." + (price % 100);
      $(".base_price").attr('data-price',price);
      $("#prd_price").text(price);
      $(".price-item").html("&#163;"+price)
    }
    function setPrice(price){
      //var final = price * 2;      
      var final = price;      
      
      //$(".sizes-container").attr('data-price',final);
      
      //var paper_price = filter_price($('.selected-variant').attr('data-price'));
       //var price_set = parseFloat(final) + parseFloat(paper_price);
      // console.log("PAPER:: "+paper_price+ " FINAL:: "+final)

      var final = String(final).replace(/(\d)(?=(\d{3})+$)/g, "$1,"); 
      $("#prd_price").text(final);
      $(".m_s").hide();
    }

  function filter_price(price){
    return   parseInt(price / 100) + "." + (price % 100);
  }

  $(".action-set").on('click',function(){
   
      var $this = $(this);
      
      $(".action-set").removeClass('selected-variant');
      $this.addClass('selected-variant');
      var price = $this.attr('data-price');
      price =  parseInt(price / 100) + "." + (price % 100);
      $(".base_price").attr('data-price',price);
      $(".price-item").html("&#163;"+price);
      var size_price = $(".sizes-container").attr('data-price');    
      
      if(size_price!=''){
        //console.log("PRICE:: "+price+ " SIZE:: "+size_price)
        price = parseFloat(size_price) * parseFloat(price);
        price = String(price).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        //console.log("AFTER PRICE:: "+price+ " SIZE:: "+size_price)
      }
      $("#prd_price").text(price);     
      
  });

  function destroycroper(){
    var price = $(".selected-variant").attr('data-price');
    price =  parseInt(price / 100) + "." + (price % 100);
    price = String(price).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    $(".base_price").attr('data-price',price);
    $(".sizes-container").attr('data-price','');
    $("#prd_price").text(price);
    $(".croper_main_image").hide();
    $(".product-Image-slider").show();
     $(".share-pinterest").show();  
    if(is_init){
        cropper.destroy();
    }
    $(".inputsize").val('');    
  }
  
$("body").on("paste keyup input", ".inputsize", function() {

       
       if(current_action == "inches"){
         if($(".in_width").val() > 0 && $(".in_height").val() > 0){    

             
           
             width_render = $(".in_width").val() + "inches";
             height_render = $(".in_height").val() + "inches";

             quantity= convert_into($(".in_width").val(),$(".in_height").val(),'inches');
             $(".sizes-container").attr('data-price',quantity);
             var result_out = quantity *getPrice();
                       
             //console.log("RESULT::: "+result_out + " Q: "+quantity);
             setPrice(result_out);
           
             // resolution = ratio($(".in_width").val(),$(".in_height").val());
             image_ratio = $(".in_width").val()/$(".in_height").val();
             init_cropper();
             
         }else{
            if(is_init){
                cropper.destroy();
            }
            $(".croper_main_image").hide();
            $(".product-Image-slider").show();
           $(".share-pinterest").show();  
            return false;
         }
        }else if(current_action == "ft"){   
           if(parseInt($(".inf_width").val()) > 10 ){
             $(".inf_width").val(11)             
           }
           if(parseInt($(".inf_height").val()) > 10 ){
             $(".inf_height").val(11)             
           }
         
           if(parseInt($(".ft_width").val()) > 0 && parseInt($(".ft_height").val()) > 0){    

             var inc_w = $(".inf_width").val();
             var inc_h = $(".inf_height").val();
             


             var c_in_width =$(".inf_width").val();
             var c_in_height =$(".inf_height").val();

             var c_ft_width =$(".ft_width").val();
             var c_ft_height =$(".ft_height").val();


var c_complete_width = parseFloat(c_ft_width) + parseFloat(c_in_width/12);
    c_complete_width = c_complete_width.toFixed(4);
      var c_complete_height = parseFloat(c_ft_height) + parseFloat(c_in_height/12);
      c_complete_height = c_complete_height.toFixed(4);

             var cal_in_width =$(".inf_width").val();
             var cal_in_height =$(".inf_height").val();

             var cal_ft_width =$(".ft_width").val();
             var cal_ft_height =$(".ft_height").val();

             if(inc_w == ""){
               //$(".inf_width").focus();
               //return false;
               cal_in_width =0;
             }
             if(inc_h == ""){
               ///$(".inf_height").focus()
               //return false;
               cal_in_height =0;
             }
              
             if(inc_w == ""){
               inc_w = 0;
             }
             if(inc_h == ""){
               inc_h = 0;
             }
             
             if(inc_w > 10){               
               c_width = 1;
               c_complete_width = parseInt(c_ft_width) + 1;
               inc_w =0;
               c_ft_width = parseInt(c_ft_width)+1

               cal_ft_width = parseInt(c_ft_width)+1
               cal_in_width=0;
             }else if(inc_w > 0 && inc_w < 10){               
               
             }else{
               
             }

             if(inc_h > 10){
               var height_inc = convert_into(1,'feet');
               c_complete_height = parseInt(c_ft_height) + 1;
               c_ft_height = parseInt(c_ft_height)+1
               inc_h = 0;

               cal_ft_height = parseInt(cal_ft_height)+1
               cal_in_height=0;
             }else if(inc_h > 0 && inc_h < 10){
               
             }else{
               
             }

             width_render = $(".ft_width").val()+ "ft" +"_"+inc_w + "in";
             height_render = $(".ft_height").val()+ "ft" +"_"+inc_h + "in";
             
             var width_c =  (parseInt(cal_ft_width)  * 30.48)  + (parseInt(cal_in_width) * 2.54) ;
             var height_c =  (parseInt(cal_ft_height)  * 30.48)  + (parseInt(cal_in_height) * 2.54) ;
             
             quantity= convert_into(width_c.toFixed(2),height_c.toFixed(2),'unitfeet');
             //console.log("W:: "+width_c+" H:: "+height_c + " q: "+quantity)
             $(".sizes-container").attr('data-price',quantity);
             var result_out = quantity *getPrice();
             
            // console.log("RESULT::: "+result_out);
             setPrice(result_out);
             
             // resolution = ratio(c_complete_width,c_complete_height);
             image_ratio = c_complete_width/c_complete_height;
             init_cropper();
           }else{
              if(is_init){
                  cropper.destroy();
              }
              $(".croper_main_image").hide();
              $(".product-Image-slider").show();
             $(".share-pinterest").show();  
              return false;
           }
        }else if(current_action == "cm"){ 
           if($(".cm_width").val() > 0 && $(".cm_height").val() > 0){     
             var width = convert_into($(".cm_width").val(),'cm');
             var height = convert_into($(".cm_height").val(),'cm');

            

             width_render = $(".cm_width").val()+"cm";
             height_render = $(".cm_height").val()+"cm";

             
             
             quantity= convert_into($(".cm_width").val(),$(".cm_height").val(),'cm');
             $(".sizes-container").attr('data-price',quantity);
             
             var result_out = quantity *getPrice();
             
             //console.log("RESULT::: "+result_out);
             setPrice(result_out);
             
             // resolution = ratio($(".cm_width").val(),$(".cm_height").val());
             image_ratio = $(".cm_width").val()/$(".cm_height").val();
             init_cropper();
           }else{
              if(is_init){
                  cropper.destroy();
              }
              $(".croper_main_image").hide();
              $(".product-Image-slider").show();
             $(".share-pinterest").show();  
              return false;
           }
        }else{
        }
        //console.log(current_action +" -  "+$(this).val());
    });
  

    
    
    function convert_into(w,h,type){
      if(type == "cm"){
        return Math.ceil(( w)* (h)/10000) ;
      }else if(type== "inches"){
        
        width = w * 2.54 ;
        height = h * 2.54 ;
        return Math.ceil(( width)* (height)/10000) ;
        
      }else if(type == "unitfeet"){
        return Math.ceil(( w)* (h)/10000) ;
      }
    }
    function init_cropper(){
      $(".product-Image-slider").hide();
      $(".croper_main_image").show();
      $(".share-pinterest").hide();  
      if(is_init){
          cropper.destroy();
      }
      is_init = true;
      var image = document.getElementById('crop_image_main');
      var save = document.getElementById('save');
      var original_image_customer = image.src;
      
      image.style.visibility = 'visible';
      cropper = new Cropper(image, {
        aspectRatio: image_ratio,
        viewMode: 1, 
        center: !1,
        zoomable: !1,
        checkCrossOrigin: true,
        checkOrientation: !1,
        dragMode: "none",
        autoCropArea: 1,
        rotatable: true,
        cropBoxResizable: 1,
        scalable: true,
        movable: !1,        
        //option:{ "width": width_set, "height": height_set },
        ready: function () {
          croppable = true;
        }
      });
  }

  
  $("#mirror_set").change(function(){
      if($(this).is(":checked")){        
        cropper.scale(-1,1);
      }else{
         cropper.scale(1); 
      }
  })
  // $('body').on('click','.cst_crop_buy',function(){

  //       var selected_variant = $(".selected-variant").attr('data-id');
  //       selected_variant = parseInt(selected_variant);
        
  //       if ( cropper == '') {
  //         alert("Invalid Input")
  //         return false;
  //       }
  //       if ( quantity == '') {
  //         alert("Invalid Input")
  //         return false;
  //       }
  //       var crop_image = cropper.getCroppedCanvas({height:height_set,width:width_set}).toDataURL('image/png');
  //       var size_width_value = width_render;
  //       var size_height_value = height_render;    
        
  //       $(".VariantHidden").val(selected_variant);        
  //       $("#SizeCustom").val(size_width_value + " "  + " x " + size_height_value + " " )
  //       $("#CropPath").val(crop_image);

  //       $(".product-form__input--quantity").val(quantity);

  //       $(".inputsize").val(''); 
  //       $("#mirror_set").prop('checked',false)
  //       $(".product-form-leos").submit();
  //   });


$("body").on("click", ".cst_crop_buy", function (event) {
    event.preventDefault();
    var selected_variant = $(".selected-variant").attr("data-id");
    selected_variant = parseInt(selected_variant);
   $(".loading-product").removeClass("hidden-leo");
    if (!cropper) {
        alert("Invalid Input");
        return false;
    }

    if (!quantity) {
        alert("Invalid Input");
        return false;
    }

    const cropImage = cropper.getCroppedCanvas({ height: height_set, width: width_set }).toDataURL("image/png");

    const uploadImage = async (imageData) => {
        const uniqueUrl = 'https://image.everwallpaper.com/wp-json/custom/v1/upload-image?timestamp=' + new Date().getTime();
        try {
            const response = await fetch(uniqueUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer YourJWTTokenHere'
                },
                body: JSON.stringify({ image: imageData }),
            });

            if (!response.ok) {
                throw new Error('无法上传图像，请稍后再试。');
            }

            const data = await response.json();
            if (data.imageUrl) {
                console.log('返回的裁剪后图像链接:', data.imageUrl);
                $("#CropPath").val(data.imageUrl);
                var size_width_value = width_render;
                var size_height_value = height_render;
                $(".VariantHidden").val(selected_variant);
                $("#SizeCustom").val(
                    size_width_value + " x " + size_height_value
                );
                $(".product-form__input--quantity").val(quantity);
                $(".inputsize").val("");
                $("#mirror_set").prop("checked", false);

                // 模拟点击购物车按钮
                $(".cst_crop_buy").closest('form').submit();
            } else {
                throw new Error('未能获取图像链接。');
            }
        } catch (error) {
            console.error('上传图像时出现错误:', error);
        }
    };
    uploadImage(cropImage);
});



  
});